import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldIcon } from 'lucide-react';
export function CredibilitySection() {
  return <section className="py-24 px-4 bg-navy-900" data-id="element-43">
      <div className="max-w-4xl mx-auto" data-id="element-44">
        <FadeIn data-id="element-45">
          <div className="bg-gradient-to-br from-navy-800 to-navy-900 p-8 md:p-12 rounded-3xl border border-gold/20 relative overflow-hidden" data-id="element-46">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-47" />

            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 relative z-10" data-id="element-48">
              <div className="shrink-0 text-center" data-id="element-49">
                <span className="text-6xl md:text-8xl font-bold text-transparent bg-clip-text bg-gold-gradient font-serif block leading-none" data-id="element-50">
                  90%
                </span>
                <span className="text-sm text-gold tracking-widest uppercase mt-2 block font-semibold" data-id="element-51">
                  De Éxito
                </span>
              </div>

              <div data-id="element-52">
                <ShieldIcon className="w-8 h-8 text-gold/50 mb-6 hidden md:block" data-id="element-53" />
                <p className="text-lg md:text-xl text-cream leading-relaxed font-light" data-id="element-54">
                  En solo 7 días, pasarás de despertarte 4 veces por noche a
                  tener una rutina donde dejas al bebé en la cuna despierto,
                  cierras la puerta y tienes toda la noche para ti. El 90% de
                  los padres que aplican la "Sincronía Daycare" reportan una
                  mejora drástica en su desempeño laboral en la primera semana.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}